import React, { useMemo } from 'react';

import BreakdownRingChart from '../../../../../../../../shared/designSystem/components/BreakdownRingChart';

// =============================================================================
// ReferrerRingChart — V1 "Basket Items" breakdown donut, migrated from
// BizCharts to the shared v2 BreakdownRingChart. The donut specifically
// slices by revenue (its `dimension="revenue"`); the sibling table is
// sorted by NAME, not revenue — so revenue lives on this chart, not in
// the section title. Top-N aggregation solves the long-tail invisible-
// slice problem for baskets with many distinct products.
//
// Input shape unchanged: list of { NAME, REVENUE, color, ... }. We normalize
// to the primitive's lowercase { value, color, revenue } contract and pass
// dimension="revenue" so its tooltip + labeling picks up the right field.
// =============================================================================

const ReferrerRingChart = ({ data = [] }) => {
  const normalized = useMemo(
    () =>
      data.map((item) => ({
        ...item,
        value: item.NAME,
        revenue: Number(item.REVENUE) || 0,
      })),
    [data]
  );

  return (
    <BreakdownRingChart
      data={normalized}
      dimension="revenue"
      dimensionLabels={{ revenue: 'Revenue' }}
    />
  );
};

export default ReferrerRingChart;
